import React from 'react';
import { usePrinterExtraStore } from '../state/storePrinterExtra';
import { useGetUrlLogoPrinter } from './useGetUrlLogoPrinter';

export const useGetMetaPrinter = () => {
	const { fetchPngUrl } = useGetUrlLogoPrinter();

    const {
        updateprinter_left1,
        updateprinter_left2,
        updateprinter_left3,
        updateprinter_left4,
        updateprinter_left5,
        updateprinter_left6,
        updateprinter_left7,
        updateprinter_right1,
        updateprinter_right2,
        updateprinter_right3,
        updateprinter_right4,
        updateprinter_right5,
        updateprinter_right6,
        updateprinter_right7,
        updateprinter_boolean,
        updateprinter_logo,

    } = usePrinterExtraStore( ( state ) => state );

  const metaPrinter = (meta) => {
    if ( meta[ 'meta-key' ] === 'printer' ) {
        updateprinter_left1(JSON.parse(meta.value).printer_left1 );
        updateprinter_left2(JSON.parse(meta.value).printer_left2 );
        updateprinter_left3(JSON.parse(meta.value).printer_left3 );
        updateprinter_left4(JSON.parse(meta.value).printer_left4 );
        updateprinter_left5(JSON.parse(meta.value).printer_left5 );
        updateprinter_left6(JSON.parse(meta.value).printer_left6 );
        updateprinter_left7(JSON.parse(meta.value).printer_left7 );
        updateprinter_right1(JSON.parse(meta.value).printer_right1 );
        updateprinter_right2(JSON.parse(meta.value).printer_right2 );
        updateprinter_right3(JSON.parse(meta.value).printer_right3 );
        updateprinter_right4(JSON.parse(meta.value).printer_right4 );
        updateprinter_right5(JSON.parse(meta.value).printer_right5 );
        updateprinter_right6(JSON.parse(meta.value).printer_right6 );
        updateprinter_right7(JSON.parse(meta.value).printer_right7 );
        updateprinter_boolean(JSON.parse(meta.value).printer_boolean );

		updateprinter_logo(JSON.parse(meta.value).printer_logo );
		
      
    }
  }
  const liveUpdateMetaPrinter = (newData) => {
    if ( newData.meta === 'printer_left1' ) {
			updateprinter_left1( newData.value );
		}

		if ( newData.meta === 'printer_left2' ) {
			updateprinter_left2( newData.value );
		}

		if ( newData.meta === 'printer_left3' ) {
			updateprinter_left3( newData.value );
		}	

		if ( newData.meta === 'printer_left4' ) {
			updateprinter_left4( newData.value );
		}

		if ( newData.meta === 'printer_left5' ) {
			updateprinter_left5( newData.value );
		}

		if ( newData.meta === 'printer_left6' ) {
			updateprinter_left6( newData.value );
		}

		if ( newData.meta === 'printer_left7' ) {	
			updateprinter_left7( newData.value );
		}	

		if ( newData.meta === 'printer_right1' ) {
			updateprinter_right1( newData.value );	
		}

		if ( newData.meta === 'printer_right2' ) {
			updateprinter_right2( newData.value );
		}

		if ( newData.meta === 'printer_right3' ) {
			updateprinter_right3( newData.value );
		}

		if ( newData.meta === 'printer_right4' ) {
			updateprinter_right4( newData.value );
		}

		if ( newData.meta === 'printer_right5' ) {
			updateprinter_right5( newData.value );
		}

		if ( newData.meta === 'printer_right6' ) {
			updateprinter_right6( newData.value );
		}

		if ( newData.meta === 'printer_right7' ) {
			updateprinter_right7( newData.value );
		}
		
		if ( newData.meta === 'printer_boolean' ) {
			updateprinter_boolean( newData.value );
		}
		if ( newData.meta === 'printer_logo' ) {
			updateprinter_logo( newData.value );
		}
  }

  return {metaPrinter, liveUpdateMetaPrinter}
}

